<!-- 客户详情 -->
<template>
    <div>
        <veui-drawer
            overlay-class="customer-details"
            placement="right"
            :footless="true"
            :outside-closable="true"
            :open="open"
            :modal="true"
            @cancel="close"
        >
            <!-- 客户信息 -->
            <div class="info">
                <div class="section-title">客户信息</div>
                <div class="columns">
                    <div class="column">
                        <div class="item">
                            <div class="title">客户姓名</div>
                            <div class="content">
                                {{ formData.name || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">执业资格证号</div>
                            <div class="content">
                                {{ formData.license || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">联系方式</div>
                            <div class="content">
                                {{ formData.phone || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员期限</div>
                            <div class="content">
                                {{ formData.duration || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">领域标签数量</div>
                            <div class="content">
                                {{ formData.domainFieldsNum || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员码绑码时间</div>
                            <div class="content">
                                {{ formData.bindTime | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">客保开始时间</div>
                            <div class="content">
                                {{ formData.ciStartTime | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">百度账号绑定手机号</div>
                            <div class="content">
                                {{ formData.passPhone || "-" }}
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="item">
                            <div class="title">客户身份</div>
                            <div class="content">
                                {{ formData.userType | userTypeFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">城市</div>
                            <div class="content">
                                {{ formData.cityName | cityNameFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员类型</div>
                            <div class="content">
                                {{ codeTypeMap[formData.codeType] || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员码归属地</div>
                            <div class="content">
                                {{ cityTypeMap[formData.cityLevel] || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">订单编号</div>
                            <div class="content">
                                {{ formData.tpOid || "-" }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">会员码失效时间</div>
                            <div class="content">
                                {{ formData.validityEnd | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">客保结束时间</div>
                            <div class="content">
                                {{ formData.ciEndTime | dateFilter }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="title">百度账号用户名</div>
                            <div class="content">
                                {{ formData.passName || "-" }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 会员订单历史 -->
            <div class="record">
                <div class="section-title">C位律师订单历史<span class="sub-title">注：仅展示尊享和精英会员</span></div>
                <veui-table :data="tableData" role="columnheader">
                    <veui-table-column
                        field="domain_name"
                        title="C位律师购买领域"
                        width="100"
                    >
                        <template #default="{domain_name}">
                            {{ domain_name }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="create_time"
                        title="C位律师购买时间"
                        width="200"
                    />
                    <veui-table-column
                        field="validityStart"
                        title="C位律师生效时间"
                        width="140"
                    >
                        <template #default="{validityStart}">
                            {{ validityStart }}
                        </template>
                    </veui-table-column>
                    <veui-table-column
                        field="validityEnd"
                        title="C位律师失效时间"
                        width="140"
                    >
                        <template #default="{validityEnd}">
                            {{ validityEnd }}
                        </template>
                    </veui-table-column>
                </veui-table>
                <!-- 分页 -->
                <veui-pagination
                    v-if="tableData && tableData.length"
                    :page="pn"
                    :page-size="rn"
                    :total="count"
                    class="pagination"
                    @redirect="pageChange"
                />
            </div>
        </veui-drawer>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 客户详情
 * @author dingzhenyue
 */
import {Drawer, Column, Table, Pagination} from 'veui';
import {userTypeFilter} from '../../customer-list/util/filter';
import {dateFilter, cityNameFilter} from '@/utils/filter';
import {codeTypeMap, cityTypeMap} from '../../customer-list/util/config';

export default {
    name: 'customer-details',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        // 机构id
        fid: {
            type: [String, Number],
            default: '234'
        },
        // 客户
        curLawyer: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        'veui-drawer': Drawer,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination
    },
    data() {
        return {
            // 历史订单
            tableData: [],
            formData: {},
            pn: 1,
            rn: 5,
            // 总数
            count: 0,
            codeTypeMap,
            cityTypeMap
        };
    },
    filters: {
        userTypeFilter,
        dateFilter,
        cityNameFilter
    },
    mounted() {
        this.getRecordData();
        this.getDetail();
        this.$wywLog.send({
            area: 'allinfo_show',
            action: 'show',
            page: 'schedule_guide',
            serverId: 18470
        });
    },
    methods: {
        /**
         * 关闭当前抽屉
         */

        close() {
            this.$emit('closeDrawer');
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.pn = pn;
            this.getRecordData();
        },

        /**
         * 获取客保记录数据
         */

        getRecordData() {
            let {fid, curLawyer, pn, rn} = this;
            this.$http
                .get('/bp/crm/getcptorderlist', {
                    params: {
                        fid: fid,
                        license: curLawyer.license || '',
                        pn,
                        rn
                    }
                })
                .then(res => {
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        return;
                    }
                    this.tableData = data?.list || [];
                    this.count = data?.count;
                    this.pn = data?.pn;
                    this.rn = data?.rn;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                });
        },

        /**
         * 获取详情
         */

        getDetail() {
            let {fid, curLawyer} = this;
            this.$http
                .get('/bp/crm/getcustomer', {
                    params: {
                        fid: fid || '',
                        license: curLawyer.license || ''
                    }
                })
                .then(res => {
                    if (!res.data) {
                        return;
                    }
                    this.formData = res.data || {};
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                });
        }
    }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/law-table.less";

.customer-details {
    /deep/.veui-dialog-content-head {
        align-items: center;
        padding-bottom: 28px;
        position: absolute;
        right: 0;
        top: 0;

        .veui-dialog-content-head-title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000;
            line-height: 16px;
        }
    }

    /deep/.veui-dialog-content {
        width: 990px;
    }

    /deep/.veui-dialog-content-body {
        margin-top: 45px;
    }

    .section-title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #000;
        line-height: 16px;
        margin-bottom: 36px;

        .sub-title {
            font-family: PingFang SC;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            margin-left: 8px;
            color: #848691;
            vertical-align: top;
        }
    }

    .columns {
        display: flex;

        .column {
            display: flex;
            flex-direction: column;

            &:last-child {
                margin-left: 220px;
            }
        }

        .item {
            display: flex;
            font-size: 14px;
            color: #333;
            line-height: 14px;
            padding-bottom: 30px;

            .title {
                width: 100px;
            }

            .content {
                margin-left: 22px;
            }
        }
    }

    .record {
        margin-top: 10px;
        margin-bottom: 45px;

        .pagination {
            float: right;
            padding-top: 30px;
        }
    }
}

.foot {
    position: absolute;
    bottom: 24px;
    right: 30px;
}

/deep/.veui-button.veui-dialog-content-head-close {
    color: #000;
}
</style>

